import UsersForm from '@/view/forms/users-form'
import { List, PlusCircle } from 'lucide-react'
import { useState } from 'react'
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs'
import { DisplayUser } from './panels/display-user'

interface IUsersPage {}

export default function UsersPage(props: IUsersPage) {
  console.log(props)

  const [tab, setTab] = useState('users')

  return (
    <div className="w-full">
      <main className="flex flex-col gap-6">
        <div className="w-full overflow-y-scrol flex justify-between">
          <Tabs defaultValue="users" className="w-[320px]" onValueChange={setTab}>
            <TabsList>
              <TabsTrigger value="users" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <List className="text-sm" />
                Usuários
              </TabsTrigger>
              <TabsTrigger value="register-user" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle className="text-sm" />
                Cadastrar Usuário
              </TabsTrigger>
            </TabsList>
          </Tabs>

          <div className="flex gap-2">
            {/* <Button className="text-acelerait-black flex gap-2 text-sm" variant="outline">
              <ListFilter />
              Filtro
            </Button> */}
          </div>
        </div>
        <div className="flex flex-col gap-4 border-acelerafit-gray-white rounded-md border p-6">
          {tab == 'users' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Usuários</h3>
                <p className="text-sm text-acelerafit-gray-dark">Gerencie e acompanhe o cadastro, status e informações dos Usuários.</p>
              </header>
              <div className="h-container-members overflow-hidden">
                <DisplayUser />
              </div>
            </>
          )}

          {tab == 'register-user' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Adicionar usuário</h3>
                <p className="text-sm text-acelerafit-gray-dark">Preencha as informações abaixo para registrar um novo usuário no sistema.</p>
              </header>

              <UsersForm />
            </>
          )}
        </div>
      </main>
    </div>
  )
}
